import { isReactNative } from 'yofobasement/utils/runtime';

let Easing = {};

if (isReactNative()) {
  Easing = require('react-native').Easing;
}

export default Easing;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Easing.js